// Twin of main-frontend/src/lib/utils/sortOptionsForDisplay.ts — keep in sync.
//
// Options whose value always sinks to the bottom of a sorted list, regardless
// of locale. The "—" not-set sentinel must stay last so a "clear / is empty"
// pick never lands mid-alphabet. (The live runtime form has no such sentinel
// today, but keeping the twin byte-identical avoids drift.)
const PIN_LAST = new Set(["—"]);

/**
 * Locale-aware alphabetical sort for SELECT option lists. Sorts on the
 * *displayed* label, not the raw key: pass `labelOf` so options ordered by
 * what the user actually reads. Returns a new array; never mutates the input.
 * `localeCompare` with the active locale is what makes accents / umlauts /
 * non-Latin scripts sort correctly — a plain `.sort()` would fall back to
 * UTF-16 code-unit order.
 */
export function sortOptionsForDisplay(
  options: string[],
  labelOf?: (option: string) => string,
  locale?: string,
): string[] {
  const pinned: string[] = [];
  const rest: string[] = [];
  for (const option of options) {
    (PIN_LAST.has(option) ? pinned : rest).push(option);
  }
  rest.sort((a, b) =>
    (labelOf?.(a) ?? a).localeCompare(labelOf?.(b) ?? b, locale, {
      sensitivity: "base",
    }),
  );
  return [...rest, ...pinned];
}
